export default __webpack_public_path__ + "static/media/person_and_box.184b9d02.svg";